export default "__VITE_ASSET__DAK8Ei8C__"